/* =========================================================================
   My Prolearning — Subscription / Offer page
   Billing toggle (monthly/yearly with price flip), rolling countdown,
   scroll reveal, FAQ single-open, scroll progress, sticky CTA, back-to-top.
   ========================================================================= */
(function () {
  "use strict";
  var root = document.querySelector(".mpl-offer");
  if (!root) return;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- billing toggle ---------- */
  var bills = [].slice.call(root.querySelectorAll("[data-bill]"));
  var amounts = [].slice.call(root.querySelectorAll(".mpl-plan__amount"));
  var billed = [].slice.call(root.querySelectorAll("[data-billed]"));
  var planLinks = [].slice.call(root.querySelectorAll("[data-href-m][data-href-y]"));
  var annualNote = document.getElementById("ofAnnualNote");
  // Each plan carries its own monthly/yearly values (data-m / data-y): a plan
  // without a yearly price keeps its monthly price, label and link.
  function pick(el, yearly) {
    var y = el.getAttribute("data-y");
    return yearly && y != null ? y : el.getAttribute("data-m");
  }
  bills.forEach(function (b) {
    b.addEventListener("click", function () {
      bills.forEach(function (x) { x.classList.remove("is-active"); x.setAttribute("aria-selected", "false"); });
      b.classList.add("is-active"); b.setAttribute("aria-selected", "true");
      var yearly = b.getAttribute("data-bill") === "y";
      amounts.forEach(function (a) {
        var v = pick(a, yearly);
        if (v == null || a.textContent === v) return;
        a.classList.remove("mpl-flip"); void a.offsetWidth; a.classList.add("mpl-flip");
        a.textContent = v;
      });
      billed.forEach(function (l) { var v = pick(l, yearly); if (v != null) l.textContent = v; });
      planLinks.forEach(function (a) {
        var card = a.closest(".mpl-plan");
        var amt = card && card.querySelector(".mpl-plan__amount");
        var hasYearly = !amt || amt.getAttribute("data-y") != null;
        a.href = yearly && hasYearly ? a.getAttribute("data-href-y") : a.getAttribute("data-href-m");
      });
      if (annualNote) annualNote.classList.toggle("show", yearly);
    });
  });

  /* ---------- rolling countdown (to next Sunday 23:59:59) ---------- */
  function deadline() {
    var n = new Date();
    var d = new Date(n.getFullYear(), n.getMonth(), n.getDate(), 23, 59, 59, 0);
    var days = (7 - d.getDay()) % 7; // 0=Sunday
    d.setDate(d.getDate() + days);
    if (d.getTime() <= n.getTime()) d.setDate(d.getDate() + 7);
    return d.getTime();
  }
  var target = deadline();
  var cd = { d: byId("cdD"), h: byId("cdH"), m: byId("cdM"), s: byId("cdS") };
  function byId(id) { return document.getElementById(id); }
  function pad(n) { return String(n).padStart(2, "0"); }
  function setCell(el, val) {
    if (!el || el.textContent === val) return;
    el.textContent = val;
    if (!reduce) { el.classList.remove("mpl-flip"); void el.offsetWidth; el.classList.add("mpl-flip"); }
  }
  function tick() {
    var diff = target - Date.now();
    if (diff <= 0) { target = deadline(); diff = target - Date.now(); }
    setCell(cd.d, pad(Math.floor(diff / 86400000)));
    setCell(cd.h, pad(Math.floor(diff % 86400000 / 3600000)));
    setCell(cd.m, pad(Math.floor(diff % 3600000 / 60000)));
    setCell(cd.s, pad(Math.floor(diff % 60000 / 1000)));
  }
  if (cd.s) { tick(); setInterval(tick, 1000); }

  /* ---------- count-up (e.g. "99 %") ---------- */
  var counters = [].slice.call(root.querySelectorAll("[data-countup]"));
  if (counters.length) {
    if (reduce || !("IntersectionObserver" in window)) {
      counters.forEach(function (el) { el.textContent = el.getAttribute("data-countup") + (el.getAttribute("data-suffix") || ""); });
    } else {
      var cio = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target, to = parseInt(el.getAttribute("data-countup"), 10) || 0, suf = el.getAttribute("data-suffix") || "", st = performance.now();
          (function tk(now) { var p = Math.min(1, (now - st) / 1000), e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(to * e) + suf; if (p < 1) requestAnimationFrame(tk); })(st);
          cio.unobserve(el);
        });
      }, { threshold: 0.6 });
      counters.forEach(function (el) { cio.observe(el); });
    }
  }

  /* ---------- FAQ : one open at a time ---------- */
  var faqs = [].slice.call(root.querySelectorAll(".of-q"));
  faqs.forEach(function (d) {
    d.addEventListener("toggle", function () {
      if (d.open) faqs.forEach(function (o) { if (o !== d) o.open = false; });
    });
  });

  /* ---------- anchor smooth scroll with header offset ---------- */
  [].forEach.call(root.querySelectorAll('a[href^="#"]'), function (a) {
    a.addEventListener("click", function (e) {
      var id = a.getAttribute("href").slice(1);
      var t = id && document.getElementById(id);
      if (!t) return;
      e.preventDefault();
      var top = t.getBoundingClientRect().top + window.scrollY - 84;
      window.scrollTo({ top: top, behavior: reduce ? "auto" : "smooth" });
    });
  });

  /* ---------- scroll progress · sticky CTA · back-to-top ---------- */
  var bar = root.querySelector(".of-progress");
  var sticky = root.querySelector(".of-sticky");
  var totop = root.querySelector(".of-totop");
  var pricing = document.getElementById("offres");
  var hdr = document.querySelector("header.site, .mpl-header");
  function onScroll() {
    var y = window.scrollY || 0;
    if (bar) { var h = document.documentElement.scrollHeight - window.innerHeight; bar.style.width = (h > 0 ? (y / h * 100) : 0) + "%"; }
    if (totop) totop.classList.toggle("show", y > 800);
    if (hdr) hdr.classList.toggle("scrolled", y > 10);
    if (sticky && pricing) {
      var pr = pricing.getBoundingClientRect();
      // show once we've scrolled past the hero, hide while the pricing block is on screen
      var pastHero = y > 620;
      var pricingVisible = pr.top < window.innerHeight && pr.bottom > 0;
      sticky.classList.toggle("show", pastHero && !pricingVisible);
    }
  }
  window.addEventListener("scroll", onScroll, { passive: true }); onScroll();
  if (totop) totop.addEventListener("click", function () { window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" }); });

  /* ---------- reveal ---------- */
  var els = [].slice.call(root.querySelectorAll(".mpl-reveal"));
  if (reduce || !("IntersectionObserver" in window)) {
    els.forEach(function (e) { e.classList.add("is-in"); });
    return;
  }
  var io = new IntersectionObserver(function (ents) {
    ents.forEach(function (en) {
      if (!en.isIntersecting) return;
      var sibs = [].slice.call(en.target.parentElement.children)
        .filter(function (c) { return c.classList.contains("mpl-reveal"); });
      en.target.style.transitionDelay = (Math.max(0, sibs.indexOf(en.target)) * 60) + "ms";
      en.target.classList.add("is-in");
      io.unobserve(en.target);
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -7% 0px" });
  els.forEach(function (e) { io.observe(e); });
})();
